module.exports = __webpack_public_path__ + "img/珍银面膜--OK_01.bbaf4012.jpg";